import React from 'react';

type Props = {
  size?: number | string;
  chopstickColor?: string;
  boxColor?: string;
  riceColor?: string;
  salmonColor?: string;
  style?: React.CSSProperties;
  className?: string;
};

const SushiMarkIcon: React.FC<Props> = ({
  size = 48,
  chopstickColor = '#FFFFFF',
  boxColor = '#000001',
  riceColor = '#FEFEFE',
  salmonColor = '#F16E53',
  style,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="230 290 150 140"
    width={size}
    height={size}
    style={style}
    className={className}
    aria-hidden="true"
  >
    <path fill={chopstickColor} d="m319.1 389.1c12.4 5.7 24.3 11.3 36.2 16.8 4.9 2.3 9.8 4.6 14.7 6.9 4.3 2 5.9 5.6 4 9.1-1.8 3.4-5.4 4.4-9.4 2.2-28.1-15.4-56.2-30.8-84.2-46.2-10.6-5.8-21.2-11.6-31.7-17.3-0.6-0.4-1.4-0.5-1.8-1-0.7-0.9-1.2-1.9-1.8-2.9 1.1-0.2 2.2-0.5 3.3-0.4 0.8 0.1 1.7 0.7 2.5 1.1 18.8 8.7 37.6 17.5 56.5 26.1 1.4 0.7 3.6 0.6 5 0 18.9-8.6 37.7-17.4 56.5-26.2 0.8-0.4 1.7-0.9 2.5-1 0.8-0.1 1.6 0.4 2.4 0.6-0.2 0.8-0.3 1.8-0.8 2.4-0.5 0.6-1.4 0.8-2.1 1.2q-24.3 13.3-48.5 26.7c-1 0.5-2 1.1-3.3 1.9z" />
    <path fill={chopstickColor} d="m307.5 395c-13.3 7.3-26 14.3-38.6 21.2-4.7 2.6-9.5 5.2-14.2 7.8-4.2 2.3-7.9 1.4-9.7-2.2-1.8-3.6-0.3-7 4.1-9 15-7 29.9-14 45-20.8 1.4-0.6 3.5-0.5 5.1-0.1 2.6 0.7 5.1 1.9 8.3 3.1z" />
    <path fill={boxColor} d="m350 337.8q0 7.5 0 15.1 0.1 5.9-5.3 8.6c-10.2 5.1-20.5 10.2-30.8 15.4-3.1 1.6-6 1.5-9.1 0q-15.3-7.7-30.5-15.3c-3.8-1.9-5.6-4.9-5.6-9.1q-0.1-14.8 0-29.5c0-4.1 1.8-7 5.5-8.8q15.3-7.6 30.5-15.3c3.2-1.6 6.2-1.6 9.4 0 10.2 5.1 20.4 10.2 30.6 15.3 3.6 1.8 5.4 4.7 5.4 8.8-0.1 4.9-0.1 9.9-0.1 14.8z" />
    <path fill={riceColor} d="m307.4 336.8l-31.3-16.3c-1.1-0.5-1.1-1.5 0-2l31.3-16.3c1.1-0.6 2.8-0.6 3.9 0l31.3 16.3c1.1 0.5 1.1 1.5 0 2l-31.3 16.3c-1.1 0.6-2.8 0.6-3.9 0z" />
    <path fill={salmonColor} d="m326.7 319.2l-15.8 8.9c-0.8 0.4-2.2 0.4-3.1 0l-15.8-8.9c-0.9-0.5-0.9-1.3 0-1.8l15.8-8.8c0.9-0.5 2.3-0.5 3.1 0l15.8 8.8c0.9 0.5 0.9 1.3 0 1.8z" />
  </svg>
);

export default SushiMarkIcon;
